import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProductCard({ product }) {
  const navigate = useNavigate();

  const { user } = useAuth();

const handleRefer = async () => {
  if (!user) {
    alert("Please login to refer products.");
    return;
  }

  const link = `${window.location.origin}/product/${product.product_id}?ref=${user.uid}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: product.name,
        text: `Check out "${product.name}" on Eyal App`,
        url: link,
      });
    } catch (err) {
      // User cancelled sharing
    }
  } else {
    await navigator.clipboard.writeText(link);
    alert("Referral link copied to clipboard!");
  }
};

  const variants = Array.isArray(product.variants)
    ? product.variants
    : [];

  const variant = variants[0];
  if (!variant) return null;

  const price = variant.price;
  const mrp = variant.mrp;

  return (
    <div style={styles.card}>
      <img
        src={variant.image || product.image}
        alt={product.name}
        style={styles.image}
      />

      <div style={styles.name}>{product.name}</div>

      <div style={styles.priceRow}>
        <span style={styles.price}>₹{price}</span>
        {mrp > price && (
          <span style={styles.mrp}>₹{mrp}</span>
        )}
      </div>

      {/* ✅ VIEW PRODUCT BUTTON */}
      <button
        style={styles.btn}
        onClick={() => navigate(`/product/${product.product_id}`)}
      >
        View Product
      </button>
{/* 
      <button
  style={styles.referBtn}
  onClick={handleRefer}
>
  💰 Refer & Earn
</button>
*/}
    </div>
  );
}

/* ---------------------------------
   STYLES (UNCHANGED)
--------------------------------- */
const styles = {
  card: {
    background: "#fff",
    borderRadius: 14,
    padding: 12,
    boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
  },
  image: {
    width: "100%",
    height: 120,
    objectFit: "contain",
    marginBottom: 8,
  },
  name: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
  },
  priceRow: {
    display: "flex",
    gap: 6,
    alignItems: "center",
    marginBottom: 8,
  },
  price: {
    fontWeight: 700,
  },
  mrp: {
    fontSize: 12,
    color: "#9ca3af",
    textDecoration: "line-through",
  },
  btn: {
    width: "100%",
    height: 36,
    borderRadius: 10,
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontWeight: 600,
  },

  referBtn: {
  width: "100%",
  height: 36,
  marginTop: 8,
  borderRadius: 10,
  border: "1px solid #16a34a",
  background: "#16a34a",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
},

};
